import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Button, DialogTitle, Stack, TextField, Typography } from '@mui/material';

import { editGroupNameAtom, selectedGroupIdAtom } from '@/interfaces/group';

interface EditGroupNameDialogProps {
  groupName: string;
  onClose: () => void;
}

export default function EditGroupNameDialog({ groupName, onClose }: EditGroupNameDialogProps) {
  const selectedGroupId = useAtomValue(selectedGroupIdAtom);
  const { mutate, data: isSuccess, isPending } = useAtomValue(editGroupNameAtom);

  const [newGroupName, setNewGroupName] = useState(groupName);
  const { t } = useTranslation();

  const tooLong = newGroupName.length > 20;
  const errorText = tooLong ? t('Settings.message.groupNameTooLong') : '';

  useEffect(() => {
    if (isSuccess === undefined) return;
    if (isSuccess) {
      onClose();
    } else {
      window.alert(t('Settings.message.editFailed'));
    }
  }, [isSuccess, onClose, t]);

  function onSaveClick() {
    mutate({ groupId: selectedGroupId, groupName: newGroupName });
  }

  return (
    <Stack gap={2} sx={{ minWidth: 480, p: 3 }}>
      <DialogTitle sx={{ px: 0 }}>{t('Common.label.manageDevices')}</DialogTitle>
      <Typography>{t('Settings.label.groupName')}</Typography>
      <TextField
        value={newGroupName}
        error={tooLong}
        helperText={errorText}
        onChange={(e) => setNewGroupName(e.target.value)}
      />

      <Stack direction="row" justifyContent="center" gap={3}>
        <Button variant="contained" onClick={onClose} sx={{ bgcolor: '#CCC', color: 'black' }}>
          {t('Common.label.cancel')}
        </Button>
        <Button
          variant="contained"
          disabled={newGroupName === '' || tooLong || isPending}
          onClick={onSaveClick}
          sx={{ bgcolor: 'info.main' }}
        >
          {t('Common.label.saveButton')}
        </Button>
      </Stack>
    </Stack>
  );
}
